export default __webpack_public_path__ + "static/media/IMG-20241210-WA0034.d2545549.jpg";